import React from 'react';
import { connect } from 'react-redux';

import {
  setButtonElementText,
  setButtonElementURL,
  setButtonElementTarget,
  setButtonElementCornerRadius,
  setButtonElementWidth,
  setButtonElementPadding
} from '../actions/button-element-actions';

import styles from '../../../../stylesheet/css/header-builder/button-element-options.css';

export const ButtonElementOptions = ({
  onTextChange,
  onURLChange,
  onTargetChange,
  onCorderRadiusChange,
  onWidthChange,
  onPaddingChange,
  options = {}
}) => {
  const { text, url, target, cornerRadius, width, padding } = options;

  const handleTextChange = e => onTextChange(e.target.value);
  const handleURLChange = e => onURLChange(e.target.value);
  const handleTargetChange = e => onTargetChange(e.target.value);
  const handleCorderRadiusChange = e => onCorderRadiusChange(e.target.value);
  const handleWidthChange = e => onWidthChange(e.target.value);
  const handlePaddingChange = e => onPaddingChange(e.target.value);

  return (
    <div>
      <header>Button text:</header>
      <input type="text" value={text} onChange={handleTextChange} />

      <header>URL:</header>
      <input type="text" value={url} onChange={handleURLChange} />

      <header>Target:</header>
      <select value={target} onChange={handleTargetChange}>
        <option value="self">_self</option>
        <option value="blank">_blank</option>
        <option value="top">_top</option>
        <option value="parent">_parent</option>
      </select>

      <header>Corner radius:</header>
      <input type="text" value={cornerRadius} onChange={handleCorderRadiusChange} />

      <header>Width:</header>
      <input type="text" value={width} onChange={handleWidthChange} />

      <header>Padding:</header>
      <input type="text" value={padding} onChange={handlePaddingChange} />

      <header>Preview:</header>
      <span className={styles.preview}
        style={{
          borderRadius: cornerRadius,
          width,
          padding
        }}>
        {text}
      </span>
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onTextChange(value) {
      dispatch(setButtonElementText({ device, id, value }));
    },

    onURLChange(value) {
      dispatch(setButtonElementURL({ device, id, value }));
    },

    onTargetChange(value) {
      dispatch(setButtonElementTarget({ device, id, value }));
    },

    onCorderRadiusChange(value) {
      dispatch(setButtonElementCornerRadius({ device, id, value }));
    },

    onWidthChange(value) {
      dispatch(setButtonElementWidth({ device, id, value }));
    },

    onPaddingChange(value) {
      dispatch(setButtonElementPadding({ device, id, value }));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ButtonElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/ButtonElementOptions.js